<template>
  <div :class="['price', { 'price_sign': hasSign }]">
    <template
      v-if="hasValidValue"
    >
      {{ value | price }}
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    hasSign: {
      type: Boolean,
      default: true,
    }
  },

  computed: {
    hasValidValue() {
      const intValue = parseInt(this.value);
      const isNotNegative = intValue >= 0;

      return isNotNegative && !isNaN(intValue);
    }
  }
}
</script>

<style lang="scss">
  .price {
    &::after {
      display: inline;
      margin-left: .3em;
      content: "\20BD";
    }
  }
</style>